import Image from "next/image";
import { integrationList } from "./constant";
import { MdArrowOutward } from "react-icons/md";

const NavIntegrationMenu: React.FC = () => {
    return (
        <section className="w-full mx-auto px-8 bg-white py-10">
            <div className="grid grid-cols-4 gap-5  max-w-7xl mx-auto px-5">
                {integrationList.map((value) => {
                    const isIntegration = value.featureTitle === "INTEGRATIONS";
                    return (
                        <div key={value.featureTitle} className={isIntegration ? "col-span-4" : ""}>
                            <div className="font-bold text-xl uppercase pb-3">{value.featureTitle}</div>
                            <hr style={{ borderTop: "1px solid #CBD5E0" }} className={isIntegration ? "pt-3" : ""} />

                            <div className={isIntegration ? "grid grid-cols-3 gap-4" : "space-y-5"}>
                                {isIntegration ? (
                                    <>
                                        {value.feature.map((data, index) => (
                                            <div className="flex gap-4 pb-5 cursor-pointer" key={index}>
                                                {data.image && <Image alt={data.imgAlt ?? ""} src={data.image ?? ""} width={64} height={64} className="pb-3" />}
                                                <div className="font-semibold text-sm pb-2 flex flex-col">
                                                    <a href={data.link} className="method-content pb-2">
                                                        {data.title}
                                                    </a>
                                                    <p className="text-sm font-normal">{data.summary}</p>
                                                </div>
                                            </div>
                                        ))}
                                    </>
                                ) : (
                                    <>
                                        {value.feature.map((data, index) => (
                                            <div key={index}>
                                                {data.title && <p className="method-content pb-2">{data.title}</p>}

                                                {data.image && <Image alt="" src={data.image ?? ""} width={320} height={195} className="pb-3" />}

                                                <p className="text-sm font-normal pb-2">{data.summary}</p>
                                                <button
                                                    onClick={() => (window.location.href = data.link ?? "")}
                                                    className="text-base font-medium flex items-start gap-2 border-4 py-2 px-3 w-fit text-white rounded-lg"
                                                    style={{ background: "#3364FA" }}
                                                >
                                                    Book a 1:1 slot now!
                                                    <MdArrowOutward size={20} />
                                                </button>
                                            </div>
                                        ))}
                                    </>
                                )}
                            </div>
                            {isIntegration && (
                                <a href="/whatsapp-integrations" className="text-base font-medium flex items-start gap-2" style={{ color: "#3364FA" }}>
                                    View all integrations
                                    <MdArrowOutward size={20} />
                                </a>
                            )}
                        </div>
                    );
                })}
            </div>
        </section>
    );
};

export default NavIntegrationMenu;
